import { Component, Inject, OnInit } from '@angular/core'
import { FormArray, FormGroup } from '@angular/forms'
import { SVG_ICON_SRC } from '../../../../../../injectors/svg-icon.injector'
import { NotificationSettingsModalService } from '../../services/notification-settings-modal.service'

@Component({
    selector: 'app-notification-settings-modal',
    templateUrl: './notification-settings-modal.component.html',
    styleUrls: ['./notification-settings-modal.component.scss'],
    providers: [NotificationSettingsModalService],
    host: { class: 'styled-modal' }
})
export class NotificationSettingsModalComponent implements OnInit {
    constructor(
        private notificationSettingsModalService: NotificationSettingsModalService,
        @Inject(SVG_ICON_SRC) public readonly svgDefaultSrc: string
    ) {}

    ngOnInit(): void {
        this.notificationSettingsModalService.getDataAndInitForm()
    }

    save(): void {
        this.notificationSettingsModalService.saveSettings()
    }

    close(): void {
        this.notificationSettingsModalService.close()
    }

    get userEmail(): string {
        return this.notificationSettingsModalService.userEmail
    }

    get userPhone(): string {
        return this.notificationSettingsModalService.userPhone
    }

    get notificationSettingsForm(): FormGroup {
        return this.notificationSettingsModalService.notificationSettingsForm
    }

    get notificationSettingsFormArray(): FormArray {
        return this.notificationSettingsModalService.notificationSettingsFormArray
    }
}
